export default "__VITE_ASSET__CV6_Unrz__"